<template>
  <div class="datatable statusPage">
    <div class="pageTop">
      <h1>数据总览</h1>
      <h2>景区选择</h2>
      <SearchSelect
        className="longSelect"
        v-model="reqForm.company_id_list"
        :options="storeList"
        :props="{
          label: 'name',
          value: 'id',
        }"
        placeholder="请选择景区"
      />
      <!-- <el-select v-model="reqForm.company_id_list"
                 clearable filterable multiple reserve-keyword
                 placeholder="请选择" class="longSelect"
                 @change="onSelectChange" ref="el-select5">
        <el-option v-for="(item, index) in storeList" :key="index" :label="`${item.name}`"
          :value="item.id" />
      </el-select> -->
      <!-- <el-select v-model="reqForm.company_id_list" clearable filterable multiple placeholder="请选择">
        <el-option v-for="item in storeList" :key="item.id" :label="item.name" :value="item.id" />
      </el-select> -->
      <!--      <SelectMore @handleSelect="handleSelect" selectType="store"></SelectMore>-->
      <el-select
        class="mineSelect"
        v-model="reqForm.source"
        clearable
        multiple
        placeholder="请选择"
        v-collapse-tags="2"
      >
        <el-option
          v-for="item in sourcelist"
          :key="item.id"
          :label="item.data"
          :value="item.id"
        />
      </el-select>
      <el-button @click="onSubmit">查询</el-button>
      <span class="text">
        对比数据中的对比率:
        <i>基于对比数据，展示参照数据的增长/降低趋势</i></span
      >
    </div>
    <template>
      <div>
        <yeardata
          v-if="updatedTotalData.length > 0"
          @searchdata="search"
          @deletedata="deleteyeardata"
          :yeardata="updatedTotalData[0].data"
          :id="updatedTotalData[0].id"
          :time="updatedTotalData[0].time"
        >
        </yeardata>

        <yeardata
          v-for="(item, index) in updatedTotalData.slice(1)"
          :key="index"
          @searchdata="search"
          @deletedata="deleteyeardata"
          :yeardata="item.data"
          :id="item.id"
          :time="item.time"
          :ratio="item.ratio"
        >
        </yeardata>
      </div>
    </template>
    <el-button class="adddate" type="primary" @click="add"
      >添加日期对比</el-button
    >
    <!-- 展示图表 -->
    <div class="dataecharts">
      <div>
        <echartsdataone :data="updatedTotalData"></echartsdataone>
      </div>
      <div>
        <echartsdatatwo :data="updatedTotalData"></echartsdatatwo>
      </div>
      <div>
        <echartsdatathree :data="updatedTotalData"></echartsdatathree>
      </div>
      <div>
        <echartsdatafour :data="updatedTotalData"></echartsdatafour>
      </div>
    </div>
  </div>
</template>

<script>
import yeardata from "./yeardata.vue";
import echartsdataone from "./EchartsOne.vue";
import echartsdatatwo from "./EchartsTwo.vue";
import echartsdatathree from "./EchartsThree.vue";
import echartsdatafour from "./EchartsFour.vue";
// import { getStoreList } from "@/api/bi"
import { getScreeningList } from "@/api/screening";
import SearchSelect from "@/views/components/SearchSelect";
import Vue from "vue";
import moment from "moment";
export default {
  name: "datatable",
  props: {
    allStore: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    yeardata,
    echartsdataone,
    echartsdatatwo,
    echartsdatathree,
    echartsdatafour,
    SearchSelect,
  },
  data() {
    return {
      type: "success",
      typeone: "success",
      totaldata: [], // 总的数据
      storeList: [],
      yearData: [],
      addyearData: [],
      data: {
        id: "",
        time: [],
        data: {
          sales_Revenue: "0",
          sales_Quantity: "0",
          scenic_Spot: "0",
          sku_Num: "0",
          deviece_num: "0",
          single_unit_Sales: "0",
          refund_Amount: "",
          refund_Rate: "0",
        },
        ratio: {
          sales_Revenue: "0",
          sales_Quantity: "0",
          // sales_Revenue: "0",
          scenic_Spot: "0",
          sku_Num: "0",
          deviece_num: "0",
          single_unit_Sales: "0",
          refund_Amount: "0",
          refund_Rate: "0",
        },
      },
      sourcelist: [
        {
          id: 1,
          data: "771/772",
        },
        {
          id: 2,
          data: "775",
        },
        {
          id: 3,
          data: "776",
        },
        {
          id: 4,
          data: "779",
        },
        {
          id: 5,
          data: "780",
        },
        {
          id: 6,
          data: "781",
        },
        {
          id: 7,
          data: "782",
        },
        {
          id: 8,
          data: "783",
        },
      ],
      reqForm: {
        company_id_list: [],
        start: "",
        end: "",
        source: [1, 2, 3, 4, 5, 6, 7, 8],
      },
    };
  },
  created() {
    // 获取三年数据
    this.getdata();
    this.getAllStore();
  },
  watch: {
    allStore: {
      immediate: true,
      handler(val) {
        this.storeList = Array.isArray(val) ? val : [];
      },
    },
  },
  computed: {
    updatedTotalData() {
      // console.log(this.addyearData);
      const updatedAddYearData = this.addyearData.map((e) => {
        return {
          ...e,
          ratio:
            e.time && e.time.length > 0 && this.addyearData[0] && this.addyearData[0].data
              ? this.handle(this.addyearData[0].data, e.data)
              : e.ratio,
        };
      });
      return updatedAddYearData;
    },
  },
  methods: {
    // 接口失败或 data 为空时的占位结构，保证页面可渲染
    buildEmptyYearData(time) {
      const empty = JSON.parse(JSON.stringify(this.data));
      empty.id =
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
      empty.time = time || [];
      return empty;
    },
    // 清除el-select搜索文本框的值query
    onSelectChange() {
      this.$refs["el-select5"].query = "";
    },
    //  初次进入获取三年数据
    getdata() {
      // let today = new Date(new Date().getFullYear(), 0, 1);
      let today = new Date();
      let year = [];
      let beforeyear = [];
      console.log(today.getMonth(),'获取的月份');
      console.log(today.getDate(),'获取的日期');
      if ((today.getMonth()!= 0) || (today.getDate()!= 1)) {
        console.log(0);
        year = [new Date(new Date().getFullYear(), 0, 1), new Date()]; // 当年
        // 将结束时间减去一天
        year[1].setDate(year[1].getDate() - 1);
        beforeyear = [
          new Date(year[0].getFullYear() - 1, 0, 1),
          new Date(
            year[1].getFullYear() - 1,
            year[1].getMonth(),
            year[1].getDate()
          ),
        ]; // 前一年的时间范围，结束日期为当前日期
      } else {
        console.log(today);
        year = [
          new Date(new Date().getFullYear() - 1, 0, 1),
          new Date(new Date().getFullYear() - 1, 11, 31),
        ]; // 当年
        beforeyear = [
          new Date(new Date().getFullYear() - 2, 0, 1),
          new Date(new Date().getFullYear() - 2, 11, 31),
        ]; // 前一年的时间范围，结束日期为当前日期
      }
      // const lastyear = [new Date(new Date().getFullYear() - 2, 0, 1), new Date(new Date().getFullYear() - 2, 11, 31)]; // 前两年
      // 使用 Promise.all 处理并发请求
      Promise.all([this.everyyeardata(year), this.everyyeardata(beforeyear)])
        .then((results) => {
          this.addyearData = [results[0], results[1]];
        })
        .catch((err) => {
          console.error('BI分析初始化失败', err);
          this.addyearData = [
            this.buildEmptyYearData(year),
            this.buildEmptyYearData(beforeyear),
          ];
        });
    },
    // 添加日期对比
    add() {
      const data = this.data;
      data.id =
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
      this.addyearData.push({
        ...data,
      });
      // console.log(this.addyearData);
      // console.log(this.updatedTotalData);
    },
    // 删除数据
    deleteyeardata(value, id) {
      // console.log(this.addyearData);
      // console.log(id);
      if (id) {
        // console.log(id)
        this.addyearData = this.addyearData.filter((v) => v.id != id);
        // console.log(this.addyearData);
      }
    },
    // 根据子组件传递过来的数据 决定查询那个数据
    search(value, id) {
      // console.log(id);
      // console.log(value);
      if (id) {
        Promise.all([this.everyyeardata(value)])
          .then((results) => {
            // console.log('返回数据结果', results);
            const data = results[0] || this.buildEmptyYearData(value);
            const checkdata =
              (this.updatedTotalData[0] && this.updatedTotalData[0].data) ||
              this.data.data;
            this.addyearData.forEach((v) => {
              if (v.id == id) {
                // console.log(id);
                // 这里是mock.JS的假数据  实际应该调用接口
                Vue.set(v, "data", data.data || this.data.data);
                Vue.set(v, "time", value);
                Vue.set(v, "ratio", this.handle(checkdata, v.data));
              }
            });
            // 在 then 回调中进行进一步处理
            // console.log('返回数据结果', this.addyearData);
          })
          .catch((err) => {
            console.error('BI分析对比查询失败', err);
            this.addyearData.forEach((v) => {
              if (v.id == id) {
                const empty = this.buildEmptyYearData(value);
                Vue.set(v, "data", empty.data);
                Vue.set(v, "time", value);
                Vue.set(v, "ratio", empty.ratio);
              }
            });
          });
      }
      // console.log("接受传输过来的数据", value, id);
      // console.log(this.addyearData);
      // console.log(this.updatedTotalData);
    },
    // 查询数据
    onSubmit() {
      if (!this.addyearData || this.addyearData.length === 0) {
        this.getdata();
        return;
      }
      this.addyearData.forEach((v, index) => {
        if (v.time && v.time.length) {
          Promise.all([this.everyyeardata(v.time)])
            .then((results) => {
              const updatedYearData =
                results[0] || this.buildEmptyYearData(v.time);
              // 保留原 id，避免对比块错乱
              updatedYearData.id = v.id || updatedYearData.id;
              updatedYearData.time = v.time;
              this.$set(this.addyearData, index, updatedYearData);
            })
            .catch((err) => {
              console.error("BI分析查询失败：", err);
              const empty = this.buildEmptyYearData(v.time);
              empty.id = v.id || empty.id;
              this.$set(this.addyearData, index, empty);
            });
        }
      });
      // console.log(this.reqForm);
      // console.log(this.addyearData);
    },
    // 处理接口返回数据
    everyyeardata(time) {
      return new Promise((resolve) => {
        if (time) {
          this.reqForm.start = moment(time[0]).format("YYYY-MM-DD");
          this.reqForm.end = moment(time[1]).format("YYYY-MM-DD");
        }
        const form = JSON.parse(JSON.stringify(this.reqForm));
        getScreeningList(form)
          .then((res) => {
            if (
              !(res && (res.code == 2000 || res.code == "2000") && res.data) ||
              typeof res.data !== "object" ||
              Array.isArray(res.data)
            ) {
              console.error("BI分析无有效数据", res);
              resolve(this.buildEmptyYearData(time));
              return;
            }

            let updatedYearData;
            // 标准结构：{ data: { sales_Revenue... }, time, ratio }
            if (res.data.data && typeof res.data.data === "object") {
              updatedYearData = JSON.parse(JSON.stringify(res.data));
            } else if (
              res.data.sales_Revenue !== undefined ||
              res.data.sales_Quantity !== undefined
            ) {
              // 兼容扁平指标结构
              updatedYearData = this.buildEmptyYearData(time);
              updatedYearData.data = {
                ...updatedYearData.data,
                ...res.data,
              };
            } else {
              // data: {} 等空对象
              console.error("BI分析返回空数据", res);
              resolve(this.buildEmptyYearData(time));
              return;
            }

            updatedYearData.id =
              Date.now().toString(36) +
              Math.random().toString(36).substr(2, 5);
            if (time) {
              updatedYearData.time = time;
            }
            this.yearData = updatedYearData;
            resolve(updatedYearData);
          })
          .catch((err) => {
            // 业务失败 code:-1：清空为占位数据，避免页面卡死或残留旧值
            console.error("BI分析接口失败", err);
            resolve(this.buildEmptyYearData(time));
          });
      });
    },
    // 处理比例数据
    handle(currentYear, previousYear) {
      // console.log(currentYear);
      // console.log(previousYear);
      const result = {};
      if (!currentYear || !previousYear) return result;
      for (const key in currentYear) {
        if (previousYear.hasOwnProperty(key)) {
          if (currentYear[key] > 0 && previousYear[key] > 0) {
            const currentValue = currentYear[key];
            const previousValue = previousYear[key];
            const percentage =
              ((currentValue - previousValue) / previousValue) * 100;
            result[key] = percentage.toFixed(2);
          } else {
            result[key] = 0;
          }
        }
      }

      return result;
    },
    getAllStore() {
      this.storeList = Array.isArray(this.allStore) ? this.allStore : [];
      // console.log('获取到的景区', this.storeList);
      // getStoreList().then((res) => {
      //   console.log(res);
      //   this.storeList = res.data;
      //   console.log('景区', this.storeList);
      // }).catch((err) => {
      //   console.log(err);
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
.dataecharts {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  /* 设置弹性盒子换行 */
  justify-content: space-around;
  align-items: center;
  //margin-top: 20px;

  div {
    margin-top: 25px;
  }
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;
}

.datatable {
  max-width: 1920px;
  min-width: 1024px;
  padding: 20px;
  color: #fff;
  background-size: cover !important;

  .adddate {
    margin-top: 20px;
  }

  .typebutton {
    background-color: #16b19f;
  }

  .pageTop {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
  }

  .pageTop h1 {
    margin-right: 30px;
    font-size: 22px;
    font-weight: bold;
  }

  .pageTop h2 {
    margin-right: 10px;
  }

  .pageTop .mineSelect {
    margin: 0 30px;
  }

  .pageTop .text {
    margin: 0 30px;
  }

  .pageTop i {
    margin: 0 5px;
    color: skyblue;
  }
}
</style>